/* LONGEVX · Módulos multimedia. Basado en el módulo Exclamación (Care Balance, v4.3). */
(() => {
  if (window.LxMediaCardsInit) return;
  window.LxMediaCardsInit = true;

  const hoverCapable = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const getCard = (t) => (t && t.closest ? t.closest('[data-xm-video-card]') : null);
  const getVideo = (card) => (card ? card.querySelector('.lx-xm__video') : null);
  const hasEndImage = (card) => Boolean(card && card.querySelector('.lx-xm__end-image'));

  const FADE = 700;
  const fadeMs = (card) => { const v = parseFloat(getComputedStyle(card).getPropertyValue('--xm-video-fade')); return Number.isFinite(v) ? v : FADE; };
  const clearStates = (card) => card && card.classList.remove('is-playing', 'is-paused-frame', 'is-last-frame', 'show-end-image');

  /* Vuelve a la portada con fundido: primero baja la opacidad del video y recién después lo pausa y lo rebobina. */
  const showCover = (card, reset = true) => {
    const v = getVideo(card);
    if (!card || !v) return;
    clearTimeout(card._xmT);
    clearStates(card);
    card.classList.remove('is-loop-fade');
    card._xmT = setTimeout(() => {
      if (card.dataset.xmActive === 'true') return;
      v.pause();
      if (reset) { try { v.currentTime = 0; } catch (e) {} }
    }, fadeMs(card) + 40);
  };

  const pauseAtFrame = (card) => {
    const v = getVideo(card);
    if (!card || !v) return;
    v.pause();
    card.classList.remove('is-playing', 'show-end-image');
    card.classList.add('is-paused-frame');
  };

  const prepare = (card) => {
    const v = getVideo(card);
    if (!card || !v) return false;
    card.classList.remove('show-end-image', 'is-last-frame', 'is-paused-frame');
    if ((card.dataset.startMode || 'restart') === 'restart') {
      try { v.currentTime = 0; } catch (e) {}
    } else if (Number.isFinite(v.duration) && v.duration > 0 && v.currentTime >= v.duration - 0.08) {
      try { v.currentTime = 0; } catch (e) {}
    }
    return true;
  };

  const play = (card) => {
    const v = getVideo(card);
    if (!card || !v) return;
    clearTimeout(card._xmT);
    /* Si vuelve a entrar mientras el video se desvanece, sigue desde donde estaba. */
    if (!v.paused && !v.ended) { card.dataset.xmActive = 'true'; card.classList.add('is-playing'); return; }
    if (!prepare(card)) return;
    card.dataset.xmActive = 'true';
    const p = v.play();
    if (p && typeof p.catch === 'function') p.catch(() => { card.dataset.xmActive = 'false'; showCover(card, false); });
  };

  const leave = (card) => {
    if (!card) return;
    card.dataset.xmActive = 'false';
    /* Si el video ya terminó, se mantiene el estado final (la imagen final sigue con su Ken Burns). */
    if (card.classList.contains('show-end-image') || card.classList.contains('is-last-frame')) {
      const v = getVideo(card);
      if (v) v.pause();
      return;
    }
    if ((card.dataset.leaveBehavior || 'cover') === 'cover') showCover(card, true);
    else pauseAtFrame(card);
  };

  const bind = (v) => {
    if (!v || v.dataset.xmBound === 'true') return;
    v.dataset.xmBound = 'true';
    const card = v.closest('[data-xm-video-card]');
    if (!card) return;
    v.addEventListener('playing', () => {
      card.classList.remove('is-paused-frame', 'is-last-frame', 'show-end-image');
      card.classList.add('is-playing');
    });
    v.addEventListener('timeupdate', () => {
      if ((card.dataset.endBehavior || '') !== 'loop' || !Number.isFinite(v.duration)) return;
      const lead = fadeMs(card) / 1000 + 0.25;
      if (v.duration - v.currentTime <= lead && card.dataset.xmActive === 'true') card.classList.add('is-loop-fade');
    });
    v.addEventListener('seeked', () => {
      if (!card.classList.contains('is-loop-fade') || v.currentTime > 0.5) return;
      setTimeout(() => card.classList.remove('is-loop-fade'), 120);
    });
    v.addEventListener('pause', () => { if (!v.ended) card.classList.remove('is-playing'); });
    v.addEventListener('ended', () => {
      card.classList.remove('is-playing', 'is-paused-frame');
      const behavior = card.dataset.endBehavior || 'last_frame';
      if (behavior === 'loop') {
        if (card.dataset.xmActive === 'true') {
          card.classList.add('is-playing', 'is-loop-fade');
          try { v.currentTime = 0; } catch (e) {}
          const p = v.play(); if (p && p.catch) p.catch(() => {});
        } else showCover(card, true);
        return;
      }
      if (behavior === 'end_image' && hasEndImage(card)) {
        card.classList.remove('is-last-frame');
        card.classList.add('show-end-image');
        return;
      }
      card.classList.remove('show-end-image');
      card.classList.add('is-last-frame');
    });
    v.addEventListener('error', () => { card.dataset.xmActive = 'false'; showCover(card, false); });
  };

  const bindAll = (root = document) => root.querySelectorAll('.lx-xm__video').forEach(bind);
  bindAll();

  document.addEventListener('mouseover', (e) => {
    if (!hoverCapable()) return;
    const card = getCard(e.target);
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    bind(getVideo(card));
    play(card);
  });

  document.addEventListener('mouseout', (e) => {
    if (!hoverCapable()) return;
    const card = getCard(e.target);
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    leave(card);
  });

  let lastPointer = 'mouse';
  document.addEventListener('pointerdown', (e) => {
    lastPointer = e.pointerType || 'mouse';
    if (lastPointer !== 'touch') return;
    document.querySelectorAll('[data-xm-video-card].is-touch-preview').forEach((c) => {
      if (c.contains(e.target)) return;
      c.classList.remove('is-touch-preview');
      c.dataset.xmArmed = 'false';
      leave(c);
    });
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const card = getCard(e.target);
    if (!card || lastPointer !== 'touch') return;
    bind(getVideo(card));
    const hasLink = card.tagName === 'A' && card.getAttribute('href');
    if (!hasLink) {
      e.preventDefault();
      if (card.classList.contains('is-touch-preview')) {
        card.classList.remove('is-touch-preview');
        card.dataset.xmArmed = 'false';
        leave(card);
      } else {
        card.classList.add('is-touch-preview');
        card.dataset.xmArmed = 'true';
        play(card);
      }
      return;
    }
    if (card.dataset.xmArmed !== 'true') {
      /* Primer toque en celular: corre el video y no navega. */
      e.preventDefault();
      card.dataset.xmArmed = 'true';
      card.classList.add('is-touch-preview');
      play(card);
      return;
    }
    /* Segundo toque: sigue el enlace. */
    card.dataset.xmArmed = 'false';
    card.classList.remove('is-touch-preview');
  });

  document.addEventListener('shopify:section:load', (e) => bindAll(e.target));
})();
